import { normalizePath } from '../seo/site'
import { contentPaths } from '../content/contentPaths'
import { lazyPage, type LazyPage } from './lazyPage'

/** Páginas do app, carregadas sob demanda. */
export const pages = {
  home: lazyPage(() => import('../pages/HomePage')),
  content: lazyPage(() => import('../pages/ContentPage')),
  consultation: lazyPage(() => import('../pages/ConsultationPage')),
  completeConsultation: lazyPage(() => import('../pages/CompleteConsultationPage')),
  login: lazyPage(() => import('../pages/LoginPage')),
  dashboard: lazyPage(() => import('../pages/DashboardPage')),
  notFound: lazyPage(() => import('../pages/NotFoundPage')),
}

const pageByPath: Record<string, LazyPage> = {
  '/': pages.home,
  '/consulta': pages.consultation,
  '/consultacompleta': pages.completeConsultation,
  '/entrar': pages.login,
  '/painel': pages.dashboard,
  '/404': pages.notFound,
  ...Object.fromEntries(contentPaths.map((path) => [path, pages.content])),
}

/** Baixa antes o código da página do endereço informado (sem efeito para endereços desconhecidos). */
export function preloadPage(pathname: string) {
  return pageByPath[normalizePath(pathname)]?.preload() ?? Promise.resolve()
}
